<template>
  <q-scroll-area
    v-bind="$attrs"
    ref="scrollArea"
    @scroll="onScroll"
  >
    <q-btn
      v-if="showScrollToStartArrow"
      icon="fas fa-chevron-left"
      :class="`fixed-${controlsPosition}-left`"
      size="sm"
      padding="sm xs"
      style="z-index: 1;"
      :style="{ 'background-image': `linear-gradient(to left, transparent, ${controlsBgColor || currentSite.backgroundColor})` }"
      text-color="responsive"
      @click="scrollToStart()"
    />
    <slot
      ref="content"
      name="content"
    />
    <q-btn
      v-if="showScrollToEndArrow"
      icon="fas fa-chevron-right"
      :class="`fixed-${controlsPosition}-right`"
      size="sm"
      padding="sm xs"
      style="z-index: 1;"
      :style="{ 'background-image': `linear-gradient(to right, transparent, ${controlsBgColor || currentSite.backgroundColor})` }"
      text-color="responsive"
      @click="scrollToEnd()"
    />
  </q-scroll-area>
</template>

<script>
import { scroll } from 'quasar'

export default {
  name: 'ScrollArea',
  props: {
    controlsBgColor: {
      type: String,
      default: null
    },
    controlsPosition: {
      type: String,
      default: 'top'
    },
    containerWidth: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      showScrollToEndArrow: false,
      showScrollToStartArrow: false,
      scrollAreaEl: null,
      scrollContent: null
    }
  },
  configuration: ['currentSite'],
  watch: {
    containerWidth () {
      if (this.containerWidth) {
        this.checkContentWidth()
      }
    }
  },
  mounted () {
    this.checkContentWidth()
  },
  methods: {
    checkContentWidth () {
      this.scrollAreaEl = this.$refs.scrollArea?.$el
      this.scrollContent = this.scrollAreaEl?.querySelector('.scroll')
      if (this.scrollContent && this.scrollAreaEl && this.scrollContent.scrollWidth > (Math.ceil(this.containerWidth) || this.scrollAreaEl.clientWidth)) {
        this.showScrollToEndArrow = true
        this.showScrollToStartArrow = false
      } else {
        this.showScrollToEndArrow = false
        this.showScrollToStartArrow = false
      }
    },
    scrollToStart () {
      scroll.setHorizontalScrollPosition(this.scrollContent, 0, 500)
      this.showScrollToStartArrow = false
      this.showScrollToEndArrow = true
    },
    scrollToEnd () {
      const maxHorizontalScroll = this.scrollContent.scrollWidth + 50 - this.scrollAreaEl.clientWidth

      scroll.setHorizontalScrollPosition(this.scrollContent, maxHorizontalScroll, 500)
      this.showScrollToStartArrow = true
      this.showScrollToEndArrow = false
    },
    onScroll (el) {
      if (el.horizontalPosition === 0) return
      const maxHorizontalScroll = this.scrollContent.scrollWidth - this.scrollAreaEl.clientWidth
      if (el.horizontalPosition > maxHorizontalScroll) {
        this.showScrollToStartArrow = true
        this.showScrollToEndArrow = false
      } else {
        this.showScrollToStartArrow = false
        this.showScrollToEndArrow = true
      }
    }
  }
}
</script>
